// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutsPage-Icon_cls1__+OUKR","cls2":"PayoutsPage-Icon_cls2__Jscp8 PayoutsPage-Icon_cls1__+OUKR"};